import { useCallback, useRef, useState } from 'react';
const MENU_ITEM_HEIGHT = 36;
const MENU_ITEM_WITH_SUBTEXT_HEIGHT = 56;

/**
 * A hook used to manage all logic needed for a virtualized Dropdown.
 * Returns properties in the format @tanstack/react-virtual expects.
 */
export default (_ref => {
  let {
    menuItems,
    isGroupHeader
  } = _ref;
  const [scrollElement, setScrollElement] = useState(null);
  const virtualParentRef = useRef(null);
  const estimateVirtualItemSize = useCallback(index => {
    const item = menuItems[index];
    if (isGroupHeader(item)) {
      return 32;
    }
    return item.subtext ? MENU_ITEM_WITH_SUBTEXT_HEIGHT : MENU_ITEM_HEIGHT;
  }, [isGroupHeader, menuItems]);
  return {
    size: menuItems.length,
    count: menuItems.length,
    parentRef: virtualParentRef,
    getScrollElement: () => scrollElement,
    setScrollElement,
    estimateSize: estimateVirtualItemSize,
    overscan: 10
  };
});
//# sourceMappingURL=useVirtualProps.js.map